import React, { useEffect, useState } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export const CommandStatusBanner = () => {
  const [message, setMessage] = useState('');
  useEffect(() => {
    const listener = (event) => setMessage(event.detail.state === 'pending' ? event.detail.message : '');
    window.addEventListener('sitepe-save-status', listener);
    return () => window.removeEventListener('sitepe-save-status', listener);
  }, []);
  if (!message) return null;
  return <div role="status" data-testid="save-pending-banner" className="mb-4 flex flex-wrap items-center gap-3 border-l-4 border-amber-500 bg-amber-50 p-4 text-sm text-amber-950">
    <AlertTriangle className="h-5 w-5 shrink-0" />
    <p className="min-w-0 flex-1" data-testid="save-pending-message">{message}</p>
    <Button variant="outline" size="sm" data-testid="save-pending-refresh" onClick={() => window.location.reload()}><RefreshCw className="mr-2 h-4 w-4" />Check again</Button>
  </div>;
};